import { CloseOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppPayFrequencySelect from '@nxsys/components/AppPayFrequencySelect';
import { PayFrequencyValue } from '@nxsys/components/AppPayFrequencySelect/type';
import TaxYearSelect from '@nxsys/components/TaxYearSelect';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Typography } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';
import AppRateInput from '@nxsys/components/AppRateInput';

export type ContributionsFilterValues = {
  payFrequency?: string;
  taxYear?: number;
  taxPeriodFrom?: number;
  taxPeriodTo?: number;
};

type ContributionsFilterModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onFilter: (values: ContributionsFilterValues) => void;
};

const ContributionsFilterModal: React.FC<ContributionsFilterModalProps> = ({
  isOpen,
  toggle,
  onFilter,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();
  const watchValue = Form.useWatch([], form);
  const ableToClearFilter =
    watchValue && Object.keys(watchValue).some((key) => !!watchValue[key]);

  const handleClearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    form.resetFields();
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    onFilter(values);
    toggle();
  };

  return (
    <AppModalContainer
      title={messages['common.filter']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      closeIcon={
        <div style={{ marginRight: 90 }}>
          <AppButton
            name={messages['common.clearAll']}
            leftIcon={<CloseOutlined />}
            onClick={handleClearAll as any}
            disabled={!ableToClearFilter}
          />
        </div>
      }
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item label={messages['common.payFrequency']} name="payFrequency">
          <AppPayFrequencySelect
            placeholder={messages['form.pleaseSelect']}
            onChange={(value: PayFrequencyValue) => {
              form.setFieldsValue({ payFrequency: value });
            }}
          />
        </Form.Item>

        <Form.Item label={messages['common.taxYear']} name="taxYear">
          <TaxYearSelect
            onFilter={(val) => {
              form.setFieldsValue({ taxYear: val.taxYear });
            }}
          />
        </Form.Item>

        <Typography.Text>{messages['common.taxPeriod']}</Typography.Text>
        <div className="grid grid-cols-2 gap-x-4 mt-2">
          <Form.Item name="taxPeriodFrom">
            <AppRateInput placeholder={messages['common.from']} />
          </Form.Item>
          <Form.Item name="taxPeriodTo">
            <AppRateInput placeholder={messages['common.to']} />
          </Form.Item>
        </div>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default ContributionsFilterModal;
